import { render, staticRenderFns } from "./cafc.vue?vue&type=template&id=1ea955e0"
import script from "./cafc.vue?vue&type=script&lang=js"
export * from "./cafc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports